import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    ExecuteOnSuccessCallback,
} from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/SaveShipping";
import { ApplicationShippingState } from "@thkStore/Store/Reducers/ShippingReducer";
import {
    buildGA4ItemsFromCartLines,
    getCurrencyCode,
    trackGA4AddShippingInfo,
} from "@thkStore/Common/Utilities/ga4EcommerceTracking";

const SendGA4AddShippingInfoEvent: typeof ExecuteOnSuccessCallback = props => {
    if (!props.cart?.cartLines?.length) {
        return;
    }

    const state = props.getState();
    const currency = getCurrencyCode(state);
    const shipping = (state as unknown as ApplicationShippingState).shipping;
    const shippingTier = shipping?.selectedCarrierName || "Standard";

    const items = buildGA4ItemsFromCartLines(props.cart.cartLines);

    trackGA4AddShippingInfo(
        items,
        currency,
        props.cart.orderGrandTotal,
        shippingTier,
        props.cart.promotionCode || undefined,
    );
};

addToChainAfter(chain, ExecuteOnSuccessCallback, SendGA4AddShippingInfoEvent);

if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}
